/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ─────────────────────────────────────────────────────────────────────────────
// Alugutter Scroll Reveal Animation
// Observes elements with .alugutter-reveal-left / .alugutter-reveal-right and
// adds .alugutter-reveal-active when they enter the viewport, triggering the
// CSS transition defined in theme.css. Stops observing each element once fired.
// ─────────────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  var observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  var observerCallback = function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('alugutter-reveal-active');
        observer.unobserve(entry.target);
      }
    });
  };

  var alugutterObserver = new IntersectionObserver(observerCallback, observerOptions);

  document.querySelectorAll('.alugutter-reveal-left, .alugutter-reveal-right').forEach(function (element) {
    alugutterObserver.observe(element);
  });
});

// ─────────────────────────────────────────────────────────────────────────────
// Alugutter Collection Description Accordion
// Turns a collection's single rich-text description into a clean accordion,
// split on the <h2> headings it already contains — with NO change to how the
// description is authored (it stays one field in the Shopify admin).
//
// Runs only on collection pages whose description has 2+ non-empty <h2>
// sections. Hub collections keep their content in tabbed sections and carry no
// <h2> in the description, so they are left completely untouched. Progressive
// enhancement: with JS disabled, the theme's native "View more" description
// still works, so nothing is lost.
//
// This only restructures content that is already in the page; it emits no
// structured data. FAQPage JSON-LD is rendered server-side, by
// sections/alugutter-collection-faq-schema.liquid on the sub-collections and by
// Alugutter-Line-Tabs on the hub collections, so that crawlers which do not
// execute JavaScript can read it.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  function initCollectionAccordion() {
    var desc = document.querySelector('.collection__description');
    if (!desc || desc.getAttribute('data-alu-accordion')) return;

    var contentRoot = desc.querySelector('.rte') || desc;

    // Guard: only act when the description is genuinely sectioned (2+ non-empty
    // H2s anywhere in the content — a descendant search, so headings hidden by a
    // malformed wrapper div still count). Skips hub pages / short descriptions.
    var allH2 = [].slice.call(contentRoot.querySelectorAll('h2')).filter(function (el) {
      return el.textContent.trim() !== '';
    });
    if (allH2.length < 2) return;

    desc.setAttribute('data-alu-accordion', '1');

    // Defensive normalisation: a stray or unclosed <div> in the authored
    // description makes the browser nest every following block inside it, which
    // would hide those headings from the top-level walk (and their content would
    // be misfiled under the previous section). Unwrap any direct-child <div>
    // that contains a heading, lifting its children into place, until the
    // heading flow is flat again. Functional wrappers (e.g. a scrollable table
    // wrapper) contain no headings, so they are left intact.
    var flatGuard = 0;
    while (flatGuard++ < 50) {
      var wrapperDiv = null;
      var kids = [].slice.call(contentRoot.children);
      for (var wi = 0; wi < kids.length; wi++) {
        if (kids[wi].tagName === 'DIV' && kids[wi].querySelector('h2')) { wrapperDiv = kids[wi]; break; }
      }
      if (!wrapperDiv) break;
      while (wrapperDiv.firstChild) contentRoot.insertBefore(wrapperDiv.firstChild, wrapperDiv);
      contentRoot.removeChild(wrapperDiv);
    }

    // Release the theme's "View more" clamp and remove its toggle button.
    desc.classList.remove('expandable-content', 'expandable-content--expandable');
    desc.style.maxHeight = 'none';
    desc.style.overflow = 'visible';
    var toggle = desc.querySelector('.expandable-content__toggle');
    if (toggle && toggle.parentNode) toggle.parentNode.removeChild(toggle);

    // Decide where the intro ends and the accordion sections begin.
    //
    // Normally the intro is everything before the first H2. But some pages lead
    // with a keyword-rich H2 used as the page title (e.g. Copings' "Secret Fix
    // Parapet Coping Systems"), with the intro prose AFTER it. When there is no
    // substantial paragraph before the first H2, we treat that first H2 as a
    // visible lead heading and keep it — plus its prose — in the (clamped)
    // intro, so the intro is not swallowed into a collapsed section and the
    // keyword heading stays visible.
    var children = [].slice.call(contentRoot.children);
    var h2Indexes = [];
    children.forEach(function (el, i) {
      if (el.tagName === 'H2' && el.textContent.trim() !== '') h2Indexes.push(i);
    });
    if (h2Indexes.length < 2) return; // safety net (the guard already checked)

    // Sum ALL text before the first H2 (not just per-block), so an intro split
    // across several short paragraphs still counts as real intro prose. A short
    // lead-time note alone stays well under the threshold → heading-lead.
    var textBeforeFirstH2 = 0;
    for (var bi = 0; bi < h2Indexes[0]; bi++) {
      textBeforeFirstH2 += children[bi].textContent.trim().length;
    }
    var substantialBeforeFirstH2 = textBeforeFirstH2 > 200;
    // Intro spans up to the first H2 (prose-lead) or the second H2 (heading-lead).
    var introEnd = substantialBeforeFirstH2 ? h2Indexes[0] : h2Indexes[1];
    var introEls = children.slice(0, introEnd);
    var sectionEls = children.slice(introEnd);

    // Group the accordion portion into one section per non-empty H2.
    var sections = [];
    var current = null;
    sectionEls.forEach(function (el) {
      var isH2 = el.tagName === 'H2';
      var text = isH2 ? el.textContent.trim() : '';
      if (isH2 && text) {
        current = { heading: el, body: [] };
        sections.push(current);
      } else if (isH2 && !text) {
        return; // drop empty headings used as delimiters
      } else if (current) {
        current.body.push(el);
      }
    });

    // Build the new structure by MOVING the original elements (not cloning),
    // so RTE typography and any links/tables are preserved exactly.
    var wrap = document.createElement('div');
    wrap.className = 'alu-collection-accordion';

    var intro = null;
    if (introEls.length) {
      intro = document.createElement('div');
      intro.className = 'alu-ca__intro';
      introEls.forEach(function (el) { intro.appendChild(el); });
      wrap.appendChild(intro);
    }

    sections.forEach(function (sec) {
      var det = document.createElement('details');
      det.className = 'alu-ca__item';
      var sum = document.createElement('summary');
      sum.className = 'alu-ca__summary';
      sum.appendChild(sec.heading); // keeps the real <h2> in the DOM for SEO
      det.appendChild(sum);
      var body = document.createElement('div');
      body.className = 'alu-ca__body';
      sec.body.forEach(function (el) { body.appendChild(el); });
      det.appendChild(body);
      wrap.appendChild(det);
    });

    contentRoot.innerHTML = '';
    contentRoot.appendChild(wrap);

    injectAccordionStyles();
    if (intro) applyIntroReadMore(intro);
  }

  function applyIntroReadMore(intro) {
    var CLAMP = 240; // px of the intro shown before the "Read more" toggle (~8 lines)
    if (intro.scrollHeight <= CLAMP + 40) return; // short intro: no clamp needed
    intro.classList.add('alu-ca__intro--clamped');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'alu-ca__readmore';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var expanded = intro.classList.toggle('alu-ca__intro--expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });
    intro.parentNode.insertBefore(btn, intro.nextSibling);
  }

  function injectAccordionStyles() {
    if (document.getElementById('alu-ca-styles')) return;
    var css =
      '.alu-collection-accordion .alu-ca__intro{margin-bottom:14px;}' +
      '.alu-ca__intro h2{font-size:1.15rem;line-height:1.3;margin:2px 0 8px;color:#4D4D4F;}' +
      '.alu-ca__intro--clamped{max-height:240px;overflow:hidden;position:relative;}' +
      '.alu-ca__intro--clamped::after{content:"";position:absolute;left:0;right:0;bottom:0;' +
        'height:52px;background:linear-gradient(rgba(255,255,255,0),#FFFFFF);pointer-events:none;}' +
      '.alu-ca__intro--clamped.alu-ca__intro--expanded{max-height:none;}' +
      '.alu-ca__intro--expanded::after{display:none;}' +
      '.alu-ca__readmore{display:inline-block;background:none;border:none;color:#FE881E;' +
        'font-weight:600;cursor:pointer;padding:6px 4px 12px;font-size:0.9rem;}' +
      '.alu-ca__readmore:hover{text-decoration:underline;}' +
      '.alu-ca__readmore:focus-visible{outline:2px solid #FE881E;outline-offset:2px;}' +
      '.alu-ca__item{border-top:1px solid #E2E5E7;}' +
      '.alu-ca__item:last-child{border-bottom:1px solid #E2E5E7;}' +
      '.alu-ca__summary{list-style:none;cursor:pointer;display:flex;align-items:center;' +
        'justify-content:space-between;gap:12px;padding:14px 4px;}' +
      '.alu-ca__summary::-webkit-details-marker{display:none;}' +
      '.alu-ca__summary h2{margin:0;font-size:1.05rem;line-height:1.35;color:#4D4D4F;}' +
      '.alu-ca__summary:hover h2{color:#FE881E;}' +
      '.alu-ca__summary:focus-visible{outline:2px solid #FE881E;outline-offset:2px;}' +
      '.alu-ca__summary::after{content:"";flex:0 0 auto;width:9px;height:9px;margin-right:6px;' +
        'border-right:2px solid #FE881E;border-bottom:2px solid #FE881E;' +
        'transform:rotate(45deg);transition:transform .2s ease;}' +
      '.alu-ca__item[open]>.alu-ca__summary::after{transform:rotate(-135deg);}' +
      '.alu-ca__body{padding:0 4px 18px;}';
    var st = document.createElement('style');
    st.id = 'alu-ca-styles';
    st.textContent = css;
    document.head.appendChild(st);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionAccordion);
  } else {
    initCollectionAccordion();
  }
})();

// ─────────────────────────────────────────────────────────────────────────────
// Alugutter "Previous Page" button (rendered by sections/breadcrumbs-alu.liquid)
// The breadcrumb parent link drops any filters the visitor had applied on the
// collection page. This records the URL of the page being left — read at unload,
// so filters the theme applies without a page load are included — and points the
// button at it. Where that URL is genuinely the previous history entry, it calls
// history.back() instead, which keeps scroll position and the cached page.
// The server-rendered breadcrumb-parent href stands as the fallback whenever
// there is nothing usable stored: direct landing, new tab, or no sessionStorage.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  var STORAGE_KEY = 'alugutter:previous-page';
  var currentUrl = window.location.href;
  var previousUrl = null;
  var storedState = null;

  try {
    storedState = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
  } catch (e) {
    storedState = null;
  }

  if (storedState && storedState.at) {
    // storedState.at matching this URL means a reload, or a back/forward onto the
    // same page, so the page before this one is the one recorded ahead of it.
    previousUrl = storedState.at === currentUrl ? storedState.from : storedState.at;
  }

  // Record this page for whatever loads next.
  window.addEventListener('pagehide', function () {
    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ from: previousUrl, at: window.location.href })
      );
    } catch (e) {
      // sessionStorage unavailable — the button keeps its fallback href.
    }
  });

  function initPreviousPageButton() {
    var link = document.querySelector('[data-previous-page-link]');

    if (!link || !previousUrl || previousUrl === currentUrl) {
      return;
    }

    // Only ever send a visitor back to a page on this store.
    if (previousUrl.indexOf(window.location.origin + '/') !== 0) {
      return;
    }

    link.href = previousUrl;

    link.addEventListener('click', function (event) {
      // Leave new-tab and new-window clicks to the browser.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      if (window.history.length > 1 && document.referrer === previousUrl) {
        event.preventDefault();
        window.history.back();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreviousPageButton);
  } else {
    initPreviousPageButton();
  }
})();
